module.exports = __webpack_public_path__ + "img/lua-stencil.2f5520a4.svg";